import { isPlatformBrowser } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    PLATFORM_ID,
    ViewEncapsulation,
} from '@angular/core';
import {
    DealerFeature,
    isHCM,
    VehicleFavoritesService,
    VehicleFeature,
    type FavoriteScope,
} from '@hyundai/ng-common-lib';
import { Store } from '@ngrx/store';

@Component({
    standalone: true,
    selector: 'lib-vehicle-favorite-button',
    templateUrl: './vehicle-favorite-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class VehicleFavoriteButtonComponent {
    slug = input.required<string>();
    private readonly platformId = inject(PLATFORM_ID);
    private readonly store = inject(Store);
    private readonly favoritesService = inject(VehicleFavoritesService);

    isHCM = isHCM();
    hwsDealer = !this.isHCM ? this.store.selectSignal(DealerFeature.state.selectLoadedDealer) : null;

    favoriteScope = computed((): FavoriteScope | null => {
        if (this.isHCM) {
            return { platform: 'hcm' };
        }

        const dealer = this.hwsDealer?.();
        if (!dealer?.id) {
            return null;
        }

        return {
            platform: 'hws',
            dealerId: dealer.id,
            dealerSlug: dealer.slug,
        };
    });

    isFavorite = computed(() => {
        this.favoritesService.favoritesChangeTick();
        const scope = this.favoriteScope();
        const slug = this.slug();

        if (!scope || !slug || !isPlatformBrowser(this.platformId)) {
            return false;
        }

        return this.favoritesService.isFavorite(scope, slug);
    });

    toggleFavorite(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        const scope = this.favoriteScope();
        const slug = this.slug();

        if (!scope || !slug || !isPlatformBrowser(this.platformId)) {
            return;
        }

        const isNowFavorite = this.favoritesService.toggle(scope, { slug });

        if (!isNowFavorite) {
            this.store.dispatch(VehicleFeature.vehicleActions.removeFavoriteVehicle({ slug }));
        }
    }
}
